module.exports = __webpack_public_path__ + "img/wncg.235497a3.svg";